import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useContext } from 'components/Admin/Webinars/Context';
import dateFormat from 'components/Admin/Webinars/Widgets/dateFormat';

export default function Details({ row }) {
  const { actions } = useContext();
  const [startUrl, setStartUrl] = useState(null);

  useEffect(() => {
    actions.start(
      row.id,
      (data) => { setStartUrl(data.start_url); },
    );
  }, []);

  return (
    <>
      <p>
        Topic:
        <br />
        <strong>{row.attributes.topic}</strong>
      </p>

      <p>
        Agenda:
        <br />
        <strong>{row.attributes.agenda}</strong>
      </p>

      <p>
        Start Date:
        <br />
        <strong>{dateFormat(row.attributes.start_date)}</strong>
      </p>

      <p>
        Start Time:
        <br />
        <strong>{row.attributes.start_time}</strong>
      </p>

      <p>
        Time Zone:
        <br />
        <strong>{row.attributes.time_zone_offset}</strong>
      </p>

      <p>
        Host:
        <br />
        <strong>{row.attributes.host}</strong>
      </p>

      <p>
        Host URL:
        <br />
        <strong>
          {startUrl ? (
            <a href={startUrl} target="_blank" rel="noreferrer" style={{ wordBreak: 'break-all' }}>
              {startUrl}
            </a>
          ) : (
            <i
              className="fa fa-spinner fa-spin"
            />
          )}
        </strong>
      </p>

      <p>
        Participant URL:
        <br />
        <strong>
          <a href={row.attributes.zoom_join_url} target="_blank" rel="noreferrer">
            {row.attributes.zoom_join_url}
          </a>
        </strong>
      </p>
    </>
  );
}

Details.propTypes = {
  row: PropTypes.object.isRequired,
};
